export type MediaUploaderMediaType = 'image' | 'video'

/** Small stable local key generator (mirrors the pattern used by the legacy ImageUpload component). */
export function uid() {
  return Math.random().toString(36).slice(2, 9)
}

/** True if the given clipboard/paste text looks like a fetchable http(s) URL. */
export function isHttpUrl(text: string) {
  return text.startsWith('http://') || text.startsWith('https://')
}

export const YOUTUBE_NOT_ALLOWED_MESSAGE =
  'YouTube links are not supported here. Paste a direct video file link or upload a file.'

/** `accept` attribute for the hidden file input, driven by mediaType. */
export function acceptForMediaType(mediaType: MediaUploaderMediaType) {
  return mediaType === 'video' ? 'video/mp4,video/webm,video/quicktime' : 'image/*'
}

/** Client-side type validation for a picked/dropped/pasted File, driven by mediaType. */
export function isValidFileForMediaType(file: File, mediaType: MediaUploaderMediaType) {
  return mediaType === 'video' ? file.type.startsWith('video/') : file.type.startsWith('image/')
}

/** User-facing message for an invalid file type. */
export function invalidFileMessage(mediaType: MediaUploaderMediaType) {
  return mediaType === 'video' ? 'Please choose a video file.' : 'Please choose an image file.'
}

/** Default failure message when uploadFile() rejects without an Error message. */
export function uploadFailedMessage(mediaType: MediaUploaderMediaType) {
  return mediaType === 'video' ? 'Failed to upload video' : 'Failed to upload image'
}
